/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IAvatar__factory } from "./IAvatar__factory";
